import React, { ButtonHTMLAttributes } from "react";
import styles from "./index.module.scss";
import classNames from "classnames";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Text to display in the button
   */
  text: string;
  /**
   * This changes the color of the button
   */
  cta?: boolean;
  /**
   * The size of the button
   */
  size?: "x-small" | "small" | "medium" | "large";
  /**
   * The color of the button
   */
  color?: string;
  /**
   * The text color of the button
   */
  textColor?: string;
}

/**
 * Button used throughout the whole shop
 */
const Button: React.FC<ButtonProps> = ({ text, cta = true, size, color, textColor, ...rest }) => {
  const additionalStyles = cta ? styles.cta : styles.normal;

  const sizeClassName = {
    "x-small": styles.xsmall,
    small: styles.small,
    medium: styles.medium,
    large: styles.large,
  }[size ?? "medium"];

  return (
    <button
      {...rest}
      style={{ backgroundColor: color, color: textColor }}
      className={classNames(styles.button, sizeClassName, additionalStyles, rest.className)}>
      {text}
    </button>
  );
};

export { Button };
